// Bootstrap the AddressAvailability.Status namespace and its static
// properties BEFORE any sub-module evaluates.  Sub-modules (views/widget,
// views/badge, etc.) reference AddressAvailability.Status.Views at class-
// definition time, so the namespace must already exist.
//
// This file MUST be imported before status/index.js in the static bundle
// (see vite-plugin-legacy-per-domain.js).

window.AddressAvailability = window.AddressAvailability || {};

window.AddressAvailability.Status = class Status {
  // Set by createStatusBadge from the server-passed request-locale catalog;
  // falls back to the catalog SparkleConfig carries for the page's locale.
  static i18n = null;

  static t(key) {
    this.i18n ??= new Sparkle.I18n(window.AddressAvailability.defaultI18n());
    return this.i18n.t(key);
  }
};
window.AddressAvailability.Status.Models = {};
window.AddressAvailability.Status.Views = {};
